var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.modalShow
        ? _c("div", { staticClass: "h-vertical-align-container" }, [
            _c("div", {
              staticClass: "modal__close",
              on: {
                click: function($event) {
                  _vm.overlay()
                }
              }
            }),
            _c("div", {
              staticClass: "modal__overlay",
              on: {
                click: function($event) {
                  _vm.overlay()
                }
              }
            }),
            _c("div", { staticClass: "videoModal__wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "fluid__video",
                  attrs: { id: "fluid__video--tutorial" },
                  domProps: { innerHTML: _vm._s(_vm.ytVideo) }
                },
                [_vm._v(_vm._s(_vm.ytVideo))]
              )
            ])
          ])
        : _vm._e(),
      _c("section", { staticClass: "full__video" }, [
        _c("div", { staticClass: "intro__content intro__content--mobile" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              id: "productLogo",
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png 1x"
            }
          }),
          _c("h2", [_vm._v("Cinemagraphs Go Mobile")]),
          _c(
            "div",
            { staticClass: "btn__group btn__group--splash" },
            [
              _c(
                "a",
                {
                  staticClass: "btn btn--purpleLight btn__splash",
                  attrs: {
                    href:
                      "https://itunes.apple.com/app/cinemagraph-pro/id642139481?mt=8"
                  }
                },
                [_vm._v("Download free trial")]
              ),
              _c("get-plan", { attrs: { classes: "btn btn--white" } })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "fluid__video" }, [
          _c("div", { staticClass: "intro__content intro__content--desktop" }, [
            _c("img", {
              staticClass: "lazy",
              attrs: {
                id: "productLogo",
                "data-srcset":
                  "https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png 1x"
              }
            }),
            _c("h2", [_vm._v("Cinemagraphs Go Mobile")]),
            _c(
              "div",
              { staticClass: "btn__group btn__group--splash" },
              [
                _c(
                  "a",
                  {
                    staticClass: "btn btn--purpleLight btn__splash",
                    attrs: {
                      href:
                        "https://itunes.apple.com/app/cinemagraph-pro/id642139481?mt=8"
                    }
                  },
                  [_vm._v("Download free trial")]
                ),
                _c("get-plan", {
                  attrs: { classes: "btn btn--white btn__splash" }
                })
              ],
              1
            )
          ]),
          _c("iframe", {
            attrs: {
              "data-src":
                "https://media.flixel.com/cinemagraph/d8okz016leqi559mmoo6?hd=true",
              allow: "autoplay"
            }
          }),
          _vm._m(0)
        ])
      ]),
      _c("brands"),
      _c("section", { staticClass: "product__section--ios" }, [
        _c("div", { staticClass: "product__section product__section--ios" }, [
          _c(
            "div",
            {
              staticClass:
                "product__section--container product__section--reverse"
            },
            [
              _c("div", { staticClass: "product__section--content" }, [
                _vm._m(1),
                _c("div", { staticClass: "productItem__desc" }, [
                  _c("p", [
                    _vm._v(
                      "The magic and ease of Cinemagraph Pro right at your fingertips. Capture, edit and create professional quality cinemagraphs on-the-go with your iPhone or iPad."
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "btn__group" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn--black",
                          attrs: {
                            href:
                              "https://itunes.apple.com/ca/app/cinemagraph-pro/id642139481?mt=8"
                          }
                        },
                        [_vm._v("Download free trial")]
                      ),
                      _c("get-plan", { attrs: { classes: "btn btn--white" } })
                    ],
                    1
                  )
                ])
              ]),
              _vm._m(2)
            ]
          )
        ])
      ]),
      _vm._m(3),
      _c("section", [
        _c("div", { staticClass: "product__section" }, [
          _c("div", { staticClass: "product__section--video" }, [
            _c(
              "a",
              {
                attrs: { href: "https://www.youtube.com/watch?v=OJ7kf2TfR24" },
                on: {
                  click: function($event) {
                    _vm.ytModal($event)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "lazy",
                  attrs: {
                    "data-srcset":
                      "https://cdn.flixel.com/static/static-web/products/ios/ios-cover@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/ios-cover.png 1x"
                  }
                }),
                _c("div", { staticClass: "playbtn" })
              ]
            )
          ])
        ])
      ]),
      _c(
        "section",
        { staticClass: "product__section product__section--callout" },
        [
          _vm._m(4),
          _vm._m(5),
          _c(
            "div",
            { staticClass: "btn__group" },
            [
              _c(
                "a",
                {
                  staticClass: "btn btn--purpleLight btn__splash",
                  attrs: {
                    href:
                      "https://itunes.apple.com/ca/app/cinemagraph-pro/id642139481?mt=8"
                  }
                },
                [_vm._v("Download free trial")]
              ),
              _c("get-plan")
            ],
            1
          )
        ]
      ),
      _vm._m(6),
      _c("section", { staticClass: "flixelPlan__section" }, [
        _c("div", { staticClass: "flixelPlan__container" }, [
          _c("h1", [_vm._v("Choose a plan that’s right for you")]),
          _c("p", [
            _vm._v(
              "Whether you’re a photographer, marketer, or designer, creating cinemagraphs is fun, fast, and easy with Cinemagraph Pro. Select a plan and start using the best cinemagraph creation tools and web-sharing platform."
            )
          ]),
          _c(
            "div",
            { staticClass: "btn__group" },
            [_c("get-plan", { attrs: { classes: "btn btn--white" } })],
            1
          )
        ])
      ]),
      _c("script", { attrs: { type: "application/ld+json" } }, [
        _vm._v(_vm._s(this.$metaInfo))
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "credit" }, [
      _c(
        "a",
        { attrs: { target: "_blank", href: "https://flixel.com/VirgoHaan/" } },
        [_vm._v("VirgoHaan")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "productItem__title" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          "data-srcset":
            "https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon@2x.png 2x,https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon.png 1x"
        }
      }),
      _c("h2", [_vm._v("Cinemagraph Pro"), _c("span", [_vm._v("for iOS")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "product__section--image" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          id: "iosImage",
          "data-srcset":
            "https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios.png 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", { staticClass: "product__section" }, [
        _c("div", { staticClass: "product__section--highlights" }, [
          _c("div", { staticClass: "highlights--title" }, [
            _c("h2", [
              _vm._v("Cinemagraph Pro for iOS is Your Mobile Creation Studio")
            ]),
            _c("p", [
              _vm._v(
                "Cinemagraph Pro for iOS lets you take professional cinemagraph production on-the-go. Create thumb-stopping cinemagraphs on an iPhone or iPad and share them instantly on social media, web, as Facebook ads, and more."
              )
            ])
          ]),
          _c("div", { staticClass: "highlights" }, [
            _c("div", { staticClass: "highlight__item" }, [
              _c("div", { staticClass: "highlight__item--icon" }, [
                _c("img", {
                  staticClass: "lazy",
                  attrs: {
                    "data-srcset":
                      "https://cdn.flixel.com/static/static-web/products/ios/features/4kcinemagraphs@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/features/4kcinemagraphs.png 1x"
                  }
                })
              ]),
              _c("div", { staticClass: "highlight__item--title" }, [
                _c("h3", [_vm._v("4K Cinemagraphs From Your iPhone or iPad")])
              ]),
              _c("div", { staticClass: "highlight__item--desc" }, [
                _c("p", [
                  _vm._v(
                    "Cinemagraphs created with Cinemagraph Pro for iOS are based in video. The quality of video used to create your cinemagraph will be the quality of your export. You can even shoot, edit and share 4K Cinemagraphs with the iPhone 7 and iPad Pro, and tell your story as vividly as you would like."
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "highlight__item" }, [
              _c("div", { staticClass: "highlight__item--icon" }, [
                _c("img", {
                  staticClass: "lazy",
                  attrs: {
                    "data-srcset":
                      "https://cdn.flixel.com/static/static-web/products/ios/features/apowerfulcinemagraph@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/features/apowerfulcinemagraph.png 1x"
                  }
                })
              ]),
              _c("div", { staticClass: "highlight__item--title" }, [
                _c("h3", [
                  _vm._v("A Powerful Cinemagraph Creation Tool in Your Pocket")
                ])
              ]),
              _c("div", { staticClass: "highlight__item--desc" }, [
                _c("p", [
                  _vm._v(
                    "Bring the entire cinemagraph creation process right to your fingertips. Capture or import your video, trim your clip, select your still image and paint over it to reveal the motion. Simple, and fast."
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "highlight__item" }, [
              _c("div", { staticClass: "highlight__item--icon" }, [
                _c("img", {
                  staticClass: "lazy",
                  attrs: {
                    "data-srcset":
                      "https://cdn.flixel.com/static/static-web/products/ios/features/easytocreate@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/features/easytocreate.png 1x"
                  }
                })
              ]),
              _c("div", { staticClass: "highlight__item--title" }, [
                _c("h3", [_vm._v("Easy to Create. Easy to Share.")])
              ]),
              _c("div", { staticClass: "highlight__item--desc" }, [
                _c("p", [
                  _vm._v(
                    "Export your beautiful cinemagraphs directly to your social networks and share them instantly. You can even save your cinemagraph as a Facebook Profile video or export it as a Apple Live Photo and set it as your lock screen image. Upload your work to your Flixel gallery, where your cinemagraphs will live infinitely."
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "highlight__item" }, [
              _c("div", { staticClass: "highlight__item--icon" }, [
                _c("img", {
                  staticClass: "lazy",
                  attrs: {
                    "data-srcset":
                      "https://cdn.flixel.com/static/static-web/products/ios/features/controlapplewatch@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/features/controlapplewatch.png 1x"
                  }
                })
              ]),
              _c("div", { staticClass: "highlight__item--title" }, [
                _c("h3", [_vm._v("Take Control with Your Apple Watch")])
              ]),
              _c("div", { staticClass: "highlight__item--desc" }, [
                _c("p", [
                  _vm._v(
                    "Your Apple Watch is your personal remote control. Capture your cinemagraph by setting a countdown timer, or use it as a remote shutter release so that you can perfect your cinemagraph selfie."
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "callout__title" }, [
      _c("h1", [_vm._v("Achieve Perfectly Looped Cinemagraphs")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "callout__text" }, [
      _c("p", [
        _vm._v(
          "Shoot perfectly still video footage using a digital camera on a tripod. Compose it like a photo with a repeated movement and capture it. Import your video into Cinemagraph Pro for macOS and let the magic begin."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", { staticClass: "product__section" }, [
        _c("div", { staticClass: "product__section--specs" }, [
          _c("h2", [_vm._v("System Requirements")]),
          _c("p", [
            _vm._v(
              "iOS 11.0 or later. Compatible with iPhone, iPad, iPad Pro, iPod Touch, and Apple Watch."
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-282ec7fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-282ec7fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/ios-fcp.vue
// module id = null
// module chunks = 